import { BrowserRouter } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import AppRoutes from './routes/AppRoutes';
import RecencyWarningDialog from './components/RecencyWarningDialog';
import { useAuth } from './contexts/AuthContext';

const AppContent = () => {
  const { showRecencyWarning, setShowRecencyWarning } = useAuth();

  return (
    <>
      <AppRoutes />
      <Toaster />
      <RecencyWarningDialog 
        open={showRecencyWarning} 
        onOpenChange={setShowRecencyWarning}
      />
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SubscriptionProvider>
          <AppContent />
        </SubscriptionProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;